import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Lenis from "lenis";
import Layout from "@/components/layout/Layout";
import { ROUTES, PAGE_KEYS } from "@/content/routes";
import Home from "@/pages/Home";
import About from "@/pages/About";
import CriticalPower from "@/pages/CriticalPower";
import DataCentre from "@/pages/DataCentre";
import Electrical from "@/pages/Electrical";
import Service from "@/pages/Service";
import References from "@/pages/References";
import Partners from "@/pages/Partners";
import PartnerPage from "@/pages/PartnerPage";
import Contact from "@/pages/Contact";

const PAGES = {
  home: <Home />,
  about: <About />,
  power: <CriticalPower />,
  dc: <DataCentre />,
  ee: <Electrical />,
  service: <Service />,
  refs: <References />,
  partners: <Partners />,
  contact: <Contact />,
};

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, wheelMultiplier: 1 });
    let frame;
    const raf = (time) => {
      lenis.raf(time);
      frame = requestAnimationFrame(raf);
    };
    frame = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(frame);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App grain">
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            {PAGE_KEYS.map((k) => (
              <Route key={`${k}-pt`} path={ROUTES[k].pt} element={PAGES[k]} />
            ))}
            {PAGE_KEYS.map((k) => (
              <Route key={`${k}-en`} path={ROUTES[k].en} element={PAGES[k]} />
            ))}
            <Route path="/partners/:slug" element={<PartnerPage />} />
            <Route path="/pt/parceiros/:slug" element={<PartnerPage />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
